// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2727":"8d420e9c416421e0","3482":"311f15db98671c73"}[chunkId] + ".css";
};